







import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { ClockCss } from "@/services/posts/postTypes/clock";

@Component
export default class ClockStyle extends Vue {
    @Prop() private itemStyle!: Style;

    get model(): ClockCss {
        return this.itemStyle.css
            ? (this.itemStyle.css as ClockCss)
            : ({} as ClockCss);
    }
}
